module.exports = __webpack_public_path__ + "static/s108_large-c69b28cbaf5f5dda140214bbdf711a1d.jpg";